module.exports = __webpack_public_path__ + "img/ex-product.8cdeb299.jpg";